// Import model
import { UpdateObjectAppointmentRequest } from '../models/UpdateObjectAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateAddressRequest } from '../models/UpdateAddressRequest';

// Import dependency serializers (for complex types)
import { UpdateAddressRequestSerializer } from './UpdateAddressRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateObjectAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateObjectAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateObjectAppointmentRequest instance
   */
  static deserialize(json: string): UpdateObjectAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateObjectAppointmentRequest instance
   */
  static fromObject(obj: any): UpdateObjectAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateObjectAppointmentRequest');
    }


    const instance: UpdateObjectAppointmentRequest = {
      address: obj['address'] ? UpdateAddressRequestSerializer.fromObject(obj['address']) : undefined as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateObjectAppointmentRequest instances
   */
  static deserializeArray(json: string): UpdateObjectAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateObjectAppointmentRequest instance to a JSON string
   */
  static serialize(instance: UpdateObjectAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateObjectAppointmentRequest instance to a plain object
   */
  static toObject(instance: UpdateObjectAppointmentRequest): any {
    return {
      'address': instance.address ? UpdateAddressRequestSerializer.toObject(instance.address) : undefined,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'contentType': instance.contentType,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateObjectAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateObjectAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
